// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","495":"feed","594":"about"}[chunkId] + "." + {"353":"7d2923ec","495":"0645d65f","594":"65cbfce3"}[chunkId] + ".css";
};